export const ORDER_STATUSES = {
  DRAFT: 100,
  PUBLISHED: 200,
  PROGRESS: 300,
  COMPLETED: 400,
  CANCELLED: 1000,
  REMOVED: 10000,
};
